module.exports = __webpack_public_path__ + "static/media/pressure-monitor-info-alert.a4498f20.svg";